var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://www.datafast.com.ec/images/verified.png","id":"poweredByDF"}})
}
var staticRenderFns = []

export { render, staticRenderFns }